<template>
    <v-dialog v-model="exibeModal" width="800" persistent>
        <v-card>
            <v-card-title
                class="body-2 font-weight-bold primary white--text"
                primary-title>
                Mais Detalhes
                <v-spacer/>
                <v-btn icon small dark @click="fecharModalReavaliacao">
                    <v-icon>fas fa-times</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="1">
                        <v-tooltip top nudge-top="-3" max-width="800" open-delay="500">
                            <template v-slot:activator="{ on }">
                                <div v-on="on" class="iconeCard d-flex justify-center align-center">
                                    <span class="textoTitulo font-weight-bold">RV</span>
                                </div>
                            </template>
                            <span>Reavaliação</span>
                        </v-tooltip>
                    </v-col>
                    <v-col cols="2" class="mt-2 px-0">
                        <span class="font-weight-bold titulo">Reavaliação</span>
                    </v-col>
                    <v-col cols="2">
                        <span class="font-weight-bold">Órgão</span>
                        <p class="mb-0">{{reavaliacao.orgao}}</p>
                    </v-col>
                    <v-col cols="3">
                        <span class="font-weight-bold">Conta Contábil</span>
                        <p class="mb-0 campo-conta-contabil">{{reavaliacao.contaContabil}}</p>
                    </v-col>
                    <v-col cols="2">
                        <span class="font-weight-bold">Finalizado por</span>
                        <p class="mb-0">{{reavaliacao.usuarioFinalizacao}}</p>
                    </v-col>
                    <v-col cols="2">
                        <span class="font-weight-bold">Finalizado em</span>
                        <p class="mb-0">{{reavaliacao.dataFinalizacao | azDate }}</p>
                    </v-col>
                </v-row>
                <v-divider/>
                <v-row>
                    <v-col cols="2" class="mt-2 mb-0 pb-0">
                        <span class="font-weight-bold titulo">DE</span>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="3">
                        <span class="font-weight-bold">Valor Líquido</span>
                        <p>{{reavaliacao.valorLiquidoAnterior | valorParaDinheiro}}</p>
                    </v-col>
                    <v-col>
                        <span class="font-weight-bold">Período Licença</span>
                        <p>{{retornaTextoPeriodoInicialAnterior()}}</p>
                    </v-col>
                </v-row>
                <v-divider/>
                <v-row>
                    <v-col cols="2" class="pb-0">
                        <span class="font-weight-bold titulo">PARA</span>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="3">
                        <span class="font-weight-bold">Valor Líquido</span>
                        <p class="mb-0">{{reavaliacao.valorLiquidoPosterior | valorParaDinheiro}}</p>
                    </v-col>

                    <v-col>
                        <span class="font-weight-bold">Período Licença</span>
                        <p class="mb-0">{{retornaTextoPeriodoInicialPosterior()}}</p>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-flex class="row pa-3 ma-0">
                    <v-btn color="grey" text outlined width="150" class="text-body-2"
                           @click="fecharModalReavaliacao">
                        Voltar
                    </v-btn>
                    <v-spacer/>
                    <v-spacer/>
                    <v-btn
                        @click="acessarVisualizacao"
                        depressed
                        width="150"
                        class="text-body-2"
                        color="primary">
                        Ver Mais
                    </v-btn>
                </v-flex>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import {mapActions} from 'vuex'
    import AzHasPermissions from '@azinformatica/loki/src/utils/AzHasPermissions'
    import {actionTypes} from '@/core/constants'

    export default {
        name: 'ModalReavaliacaoDetalhes',
        $_veeValidate: {
            validator: 'new',
        },
        data() {
            return {
                exibeModal: true,
                reavaliacao: {}
            }
        },
        computed: {
            verificaPermissaoEdicao() {
                return AzHasPermissions(this.$store.state.loki.user.authorities, ['Patrimonio.Normal'])
            }
        },
        async mounted() {
            this.reavaliacao = await this.buscarReavaliacaoPorId(this.$route.params.reavaliacaoId)
        },
        methods: {
            ...mapActions([
                actionTypes.REAVALIACAO.BUSCAR_REAVALIACAO_POR_ID
            ]),
            fecharModalReavaliacao() {
                this.$emit('fecharModalReavaliacao')
            },
            retornaTextoPeriodoInicialAnterior() {
                const dataInicio = this.reavaliacao.periodoInicialAnterior
                const dataFim = this.reavaliacao.periodoFinalAnterior
                return `${this.$options.filters.azDate(dataInicio)} a ${this.$options.filters.azDate(dataFim)}`
            },
            retornaTextoPeriodoInicialPosterior() {
                const dataInicio = this.reavaliacao.periodoInicialPosterior
                const dataFim = this.reavaliacao.periodoFinalPosterior
                return `${this.$options.filters.azDate(dataInicio)} a ${this.$options.filters.azDate(dataFim)}`
            },
            acessarVisualizacao() {
                this.$emit('acessarVisualizacao', this.reavaliacao)
            }
        }
    }
</script>

<style lang="stylus">
    .titulo
        color #0067A5

    .campo-conta-contabil
        overflow hidden
        text-overflow ellipsis
        white-space nowrap
</style>
